/* eslint-disable */
import "./App.css";
// import "bootstrap/dist/css/bootstrap.min.css test";
import { Routes, Route, BrowserRouter, Navigate, useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";
import JourneyBuilder from "./components/journeyComponent/JourneyBuilder";
///Components
import Login from "./components/assetLibComponents/pages/login/Login";
import Header from "./components/assetLibComponents/shared/header/Header";
// import AssetLibraryContainer from "./components/assetLibComponents/pages/AssetLibraryContainer";
// import CreateFolder from "./components/assetLibComponents/pages/asset-library/asset-list/CreateFolder";
// import AssetDetails from "./components/assetLibComponents/pages/asset-library/asset-list/AssetDetails";
// import NewAssetContainer from "./components/assetLibComponents/pages/asset-library/asset-upload/NewAssetContainer";
// import SelectAssetType from "./components/assetLibComponents/pages/asset-library/asset-upload/SelectAssetType";
// import AddingData from "./components/assetLibComponents/pages/asset-library/asset-upload/AddingData";
// import GlobalFields from "./components/assetLibComponents/pages/asset-library/asset-upload/GlobalFields";
// import Base from "./components/assetLibComponents/pages/asset-library/asset-upload/Base";
// import UploadedData from "./components/assetLibComponents/pages/asset-library/asset-upload/UploadedData";
// import Edit from "./components/assetLibComponents/pages/asset-library/asset-upload/Edit";
import CRMContainer from "./components/crmComponents/CRMContainer";
import ChatContainer from "./components/chatAiComponents/ChatContainer";

// import DealRoomContainer from "./components/dealRoomComponents/pages/DealRoomContainer";
// import CreateDRTemplate from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/CreateDRTemplate";
// import CreateDRDeal from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/CreateDRDeal";
// import DRDealTemplateContainer from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRDealTemplateContainer";
// import DRIntroduction from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRIntroduction";
// import DRSetup from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRSetup";
// import DRDealTimeline from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRDealTimeline";
// import DRDealEditTimeline from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRDealEditTimeline";
// import DRSection from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRSection";
// import DRDealEmailSharing from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRDealEmailSharing";

// import DocumentViewer from "./components/docViewerComponents/pages/document-viewer/DocumentViewer";
// import Intro from "./components/docViewerComponents/pages/intro/Intro";
// import DocViewerHeader from "./components/docViewerComponents/shared/header/Header";
// import SideMenu from "./components/shared/side-menu/SideMenu"; 

//Redux-imports
import { useDispatch, useSelector } from "react-redux";
import {
  setAssetLibUnauthorized,
  logout,
} from "./redux/actions/assetLibActions";
import {setDRUnauthorized} from "./redux/actions/dealRoomActions"
// import SectionAssetLibrary from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/SectionAssetLibrary";
// import DRTemplatePublish from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRTemplatePublish";
// import DocumentViewerPreviewer from "./components/docViewerComponents/pages/document-viewer/DocumentViewerPreview";
// import AccessLogin from "./components/docViewerComponents/pages/AccessLogin";
// import DocumentViewerContainer from "./components/docViewerComponents/pages/document-viewer/DocumentViewerContainer";
// import DRDealMutualActionPlan from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRDealMutualActionPlan";
// import DRDealMeetings from "./components/dealRoomComponents/pages/deal-room/deal-room-creations/DRDealMeetings";
import { setCRMUnauthorized } from "./redux/actions/crmActions";
import Emails from "./components/crmComponents/tab-components/Emails";
import LeadDetail from "./components/crmComponents/LeadDetail";
import DetailedHistory from "./components/crmComponents/tab-components/DetailedHistory";
import { setChatAiUnauthorized } from "./redux/actions/chatAiActions";
import SettingContainer from "./components/settingComponents/SettingContainer";
import StartedComponent from "./components/gettingStartedComponents/StartedComponent";
import AddUser from "./components/settingComponents/AddUser";
import { setSettingUnauthorized } from "./redux/actions/settingActions";
import Conversation from "./components/conversationComponents/Conversation";
import { setConversationUnauthorized } from "./redux/actions/conversationActions";
import LoginComponent from './components/assetLibComponents/pages/login/LoginComponent';
import SignUpComponent from './components/assetLibComponents/pages/login/SignUpComponent';
import ForgetPassword from './components/assetLibComponents/pages/login/ForgetPassword';
import ResetPassword from './components/assetLibComponents/pages/login/ResetPassword';
import Confirm from './components/assetLibComponents/pages/login/Confirm';
import AccountContainer from './components/companyAccount/AccountContainer';
import AccountDetail from './components/companyAccount/AccountDetail';
import AccountDetailedHistory from './components/companyAccount/tab-components/AccountDetailedHistory';
import { ProductFruits } from 'react-product-fruits';
import GoogleFontLoader from "react-google-font-loader";
import Analytics from "./components/analyticsComponents/Analytics";
import AnalyticsContainer from "./components/Analytics/AnalyticsContainer";
import { setDashboardUnauthorized } from "./redux/actions/dashboardAction";
import Page404 from './components/Page404';
import TrialEnd from "./components/TrialEnd";
import VerifyAccount from "./components/assetLibComponents/pages/login/VerifyAccount";
import Onboarding from "./components/Onboarding";
import VerifyTemp from "./components/assetLibComponents/pages/login/VerifyTemp";
import LiveChatContainer from "./components/liveChat/LiveChatContainer";
import Inbox from "./components/liveChat/Inbox";
import AmaContainer from "./components/InternalAma/AmaContainer";
import Intent from "./components/intentComponents/Intent";
import { setIntentUnauthorized } from "./redux/actions/intentAction";
import Intel from "./components/intentComponents/Intel";
import IntelSetting from "./components/intentComponents/IntelSetting";
import IntelDetailedHistory from "./components/companyAccount/tab-components/IntelDetailedHistory";
import DashboardAccount from "./components/analyticsComponents/DashboardAccount";
import ConsumeSso from "./components/ConsumeSso";

import JourneyListing from "./components/journeyComponent/JourneyListing";
import { setJourneyUnauthorized } from "./redux/actions/journeyAction";


function App() {
  const dispatch = useDispatch();

  const [pageType, getPageType] = useState("");
  const [headerType, getHeaderType] = useState(false);
  const [dealRoomId, setDealRoomId] = useState("");
  const [timelineStatus, setTimelineStatus] = useState(false);
  const [userInfoDetails, setUserInfoDetails] = useState({});
  const [trialCheck, setTrialCheck] = useState(false);

  const appType = localStorage.getItem("appType");
  const assetUnauthorized = useSelector(
    (state) => state.assetLibrary.unauthorizedAssetLibrary
  );
  
  const accountUnauthorize = useSelector(
    (state) => state.account.unAuthorisedAccount
  );
  
  const dealRoomSwitch = useSelector(
    (state) => state.assetLibrary.dealRoomSwitch
  );
  const crmUnauthorized = useSelector(
    (state) =>state.crmLeads.unAuthorisedCrm
  );
  const chatAiUnauthorized = useSelector(
    (state) =>state.chatAi.unAuthorisedChatAi
  );
  const settingUnauthorized = useSelector(
    (state) =>state.setting.unAuthorisedSetting
  );
  const conversationUnauthorized = useSelector(
    (state) =>state.conversation.unAuthorisedConversation
  );
  const intentUnauthorized = useSelector(
    (state) =>state.intent.unAuthorisedIntent
  );
  const journeyUnauthorized = useSelector(
    (state) =>state.journey.unAuthorisedJourney
  );
  const dashboardUnauthorized = useSelector(
    (state) =>state.dashboard.unAuthorisedDashboard
  );
  const zoomCode = useSelector((state) => state.dealRoom.zoomCode);

  const dealUnauthorized = useSelector(
    (state) => state.dealRoom.unauthorizedDealRoom
  );


  const fonts = [
    {
      font: 'Open Sans',
      weights: [400, 700],
    },
    {
      font: 'Roboto',
      weights: [300, 400],
    },
    {
      font: 'Montserrat',
      weights: [300, 400],
    },
    {
      font: 'Inter',
      weights: [300, 400],
    },
    {
      font: 'Mukta',
      weights: [300, 400],
    },
    {
      font: 'Nunito',
      weights: [300, 400],
    },
    {
      font: 'Quicksand',
      weights: [300, 400],
    },
    {
      font: 'Abel',
      weights: [300, 400],
    },
    {
      font: 'Poppins',
      weights: [300, 400],
    },
    // Add more fonts as needed
  ];


  const pageTypeHandler = (title) => {
    getPageType(title);
  };

  const headerHandler = (status) => {
    getHeaderType(status);
  };

  const timelineHandler = () => {
    setTimelineStatus(!timelineStatus);
  };

  const authToken = localStorage.getItem("authToken")
    ? localStorage.getItem("authToken").slice(1, -1)
    : "";
  const userType = localStorage.getItem("userType")
    ? localStorage.getItem("userType")
    : ""; 

  if (
    assetUnauthorized == 401 ||
    assetUnauthorized == 403 ||
    settingUnauthorized == 401 ||
    settingUnauthorized == 403 ||
    conversationUnauthorized == 401 ||
    conversationUnauthorized == 403 ||
    intentUnauthorized == 401 ||
    intentUnauthorized == 403 ||
    dealUnauthorized == 401 ||
    dealUnauthorized == 403 ||
    crmUnauthorized == 403 ||
    crmUnauthorized == 401 ||
    chatAiUnauthorized == 403 ||
    chatAiUnauthorized == 401 ||
    dashboardUnauthorized == 403 ||
    dashboardUnauthorized == 401  ||
    journeyUnauthorized == 403 ||
    journeyUnauthorized == 401
    // accountUnauthorize == 403 ||
    // accountUnauthorize == 401
  ) {
    if (Cookies.get("conditionalLogout") !== true) {
      Cookies.set("conditionalLogout", true );
      dispatch(logout(authToken));
      dispatch(setAssetLibUnauthorized(null));
      dispatch(setDRUnauthorized(null));
      dispatch(setCRMUnauthorized(null));
      dispatch(setChatAiUnauthorized(null));
      dispatch(setSettingUnauthorized(null));
      dispatch(setConversationUnauthorized(null));
      dispatch(setDashboardUnauthorized(null));
      dispatch(setIntentUnauthorized(null));
      dispatch(setJourneyUnauthorized(null));
      localStorage.clear();
      window.location = window.location.origin
      const currentURL = window.location.pathname;
      const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
      Cookies.remove("currentURL");
      Cookies.set("currentURL", currentURL === "/404" ? "/Chat-Ai" : currentURL, { expires: expiryDate });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  const isAlphanumeric = (str) => {
    return /^[a-zA-Z0-9]+$/.test(str);
  }

  let tempUrl = `${window.location.href}`;
  if (tempUrl.split('/')[4] !== "" && tempUrl.split('/')[4] !== null && tempUrl.split('/')[4] !== undefined && 
  isAlphanumeric(tempUrl.split('/')[4]) && tempUrl.split('/')[3] == 'dealRoom') {
    //localStorage.clear();
    localStorage.setItem("appType", "DealRoom");
    // window.location.reload();
    dispatch({ type: "SET_DEAL_ROOM_ID", payload: tempUrl.split('/')[4] });
  }else if(tempUrl.split('/')[3]=="Asset%20Library" ){
    localStorage.setItem("appType", "AssetLibrary");
  }
  else {
    localStorage.setItem("appType", "AssetLibrary");
  }

  if (window.location.href.indexOf("?code") > -1) {
    let tempUrl = `${window.location.href}`;
    let url = new URL(tempUrl);
    let currToken = url.searchParams.get("code");
    dispatch({ type: "SET_ZOOM_CODE", payload: currToken });
    //let currToken = tempUrl.split("?token=")[1];
    //localStorage.setItem("tokenLogin", currToken);
  }

  useEffect(() => {
    /* !!!!!!!!!!!!!!!!!!!!!!!!!!
     THIS IS THE IMPORTANT PART
     You need to provide the ProductFruits component with current logged-in user information. */

     const userData = localStorage.getItem("userData")
    ? localStorage.getItem("userData")
    : ""; 
     const userDetails = userData && JSON.parse(userData)?.data;

     if(userDetails){
       const userInfo = {
        username: userDetails?.id,
        email: userDetails?.email,
        firstname: userDetails?.first_name,
        lastname: userDetails?.last_name,
        signUpAt: '==REPLACE (optional)==',
        role: '==REPLACE (optional)==',
        props: { customProp1: '==REPLACE (optional)==' }
    };
    setUserInfoDetails(userInfo);
     }   
  }, [])

  const currentUrl= Cookies.get("currentURL");
  const uData = JSON.parse(localStorage.getItem("userData"));
  // const trialCheck = uData?.stripeData?.stripe_day_count > 0

  useEffect(()=>{
    setTrialCheck(uData?.stripeData?.stripe_day_count > 0)
  },[uData])

  let env_check = tempUrl.search("app.askzoi.ai") > 0 ? 'production' : "dev";
  let onboarding_check = tempUrl.search("Onboarding") > 0 ? true : false;

  const rValues = uData?.data
  
  return (
    <main>
      <div className="assetLibApp">
          <BrowserRouter>
            {authToken && !onboarding_check && <Header authToken={authToken} pageType={pageType} />}
            <Routes>
              <Route path="/" element={!authToken ? (<div className="login-page"> <Login/> </div>) : (<Navigate to="/internal_ama"/>)}>
                <Route path="/" element={<LoginComponent title="Login" />} />
                <Route path="/signup" index={false} element={!authToken ? <SignUpComponent title="Register" />:<Navigate to="/Analytics" />} />
                <Route path="/signup/:userEmail&&:websiteUrl" index={false} element={!authToken ? <SignUpComponent title="Register" />:<Navigate to="/Analytics" />} />
                <Route path="/forgetpassword" index={false} element={<ForgetPassword title="Forget Password" />} />
                <Route path="/resetpassword" index={false} element={<ResetPassword title="Reset Password" />} />
                <Route path="/checkemail" index={false} element={<Confirm title="Confirm Sent" />} />
                <Route path="/verifyAccount/:code" index={false} element={<VerifyAccount title="Verify Account" />} />
                <Route path="/verifyTemp/:code" index={false} element={<VerifyTemp title="Verify Temp" />} />
              </Route>
              
              {/* SSO Consume Route */}
              <Route path="/sso/consume" element={<ConsumeSso />} /> 
               <Route path="/Chat-Ai" >
                <Route index={true} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="chatAi" subPageName="url"/>} />
                <Route path="assets" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="assets" authToken={authToken} />} />
                <Route path="text" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="text" authToken={authToken} />} />
               {rValues?.fine_tune && <Route path="tuning" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="tuning" authToken={authToken} />} />}
               {rValues?.lead_capture &&<Route path="engage" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="engage" authToken={authToken} />} />}
                {/* <Route path="settings" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="settings" authToken={authToken} />} /> */}
               {rValues?.design && <Route path="design" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="design" authToken={authToken} />} />}
               {rValues?.developer && <Route path="developer" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="developer" authToken={authToken} />} />}
              <Route path="gettingStarted" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="chatAi" subPageName="gettingStarted" authToken={authToken} />} />
                {/* <Route path="addLeads" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="chatAi" subPageName="addLeads" authToken={authToken} />} /> */}
                {/* <Route path="leadDetail/:id" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="leadDetail" authToken={authToken} />} /> */}
                {/* <Route path="leadDetail/:id/add-mail" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
              </Route>

              <Route path="/Lead-Management" >
                <Route index={true} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="leadManagement" subPageName="leadView"/>} />
                <Route path="accounts" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="leadManagement" subPageName="accounts" authToken={authToken} />} />
                <Route path="addAccounts" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="addAccounts" authToken={authToken} />} />
                <Route path="addLeads" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="addLeads" authToken={authToken} />} />
                <Route path="leadDetail/:id" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="leadDetail" authToken={authToken} />} />
                <Route path="leadImport" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="leadImport" authToken={authToken} />} />
                <Route path="leadMapping" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="leadMapping" authToken={authToken} />} />
                {/* <Route path="leadDetail/:id/add-mail" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
            </Route>
            
              <Route path="/livechat/:name/:status" >
                  <Route index={true} element={<LiveChatContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="livechat" subPageName="mainChat"/>} />
              </Route>

              {/* <Route path="/livechat/setting" >
                  <Route index={true} element={<LiveChatContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="livechat" subPageName="chatSetting"/>} />
              </Route> */}

              <Route path="/livechat" >
                <Route index={false} path="setting/canned" element={<LiveChatContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="livechat" subPageName="chatSetting"/>} />
              </Route>
            
              <Route path="/analytics" >
                <Route index={true} element={<AnalyticsContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="analytics" subPageName="home"/>} />
                <Route  index={false} path=":id" element={<AnalyticsContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="analytics" subPageName="internalChat"/>} />
              </Route>
            
              <Route path="/internal_ama" >
                <Route index={true} element={<AmaContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="internalAma" subPageName="home"/>} />
                <Route  index={false} path=":id" element={<AmaContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="internalAma" subPageName="internalChat"/>} />
              </Route>


              {/* <Route path="/livechat/:name/:status" element={<LiveChatContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="livechat" subPageName="mainChat"/>}>
                <Route index={true} element={<Inbox pageTypeHandler={pageTypeHandler} displayType="1" pageName="liveChat" subPageName="chat" authToken={authToken} />} />
              </Route> */}
            
              <Route path="/Account" >
                <Route index={true} element={<AccountContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="Account" subPageName="account"/>} />
              </Route>
            
              <Route path="/journey" >
                <Route index={true} element={<JourneyListing pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="JourneyListing" subPageName="journeyListing"/>} />
                <Route path="builder/:id" element={<JourneyBuilder pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="Journey" subPageName="journey"/>} />
              </Route>
            
              <Route path="/Account/companyDetail/:id" element={<AccountDetail pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="Account" subPageName="accountDetail"/>}>
                <Route index={true} element={<AccountDetailedHistory pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads"/>} />
              </Route>
              <Route path="/Account/intel/:id" element={<AccountDetail pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="Account" subPageName="accountDetail"/>}>
                <Route index={true} element={<IntelDetailedHistory pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads"/>} />
              </Route>
            
               {rValues?.conversation &&<Route path="/Conversation" >
                <Route index={true} element={<Conversation pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="conversation" subPageName="conversation"/>} />
                {/* <Route path="leadDetail/:id" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="leadDetail" authToken={authToken} />} /> */}
                {/* <Route path="leadDetail/:id/add-mail" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
              </Route>}
               <Route path="/Intent" >
                <Route index={true} element={<Intent pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="intent" subPageName="intent"/>} />
                {/* <Route path="leadDetail/:id" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="leadDetail" authToken={authToken} />} /> */}
                {/* <Route path="leadDetail/:id/add-mail" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
              </Route>
               {rValues?.intent && <Route path="/Intel" >
                <Route index={true} element={<Intel pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="intel" subPageName="intel"/>} />
                <Route path="Setting" index={false} element={<IntelSetting pageTypeHandler={pageTypeHandler} pageName="intelSetting" subPageName="intelSetting" authToken={authToken} />} />
                {/* <Route path="leadDetail/:id/add-mail" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
              </Route>}
              {rValues?.dashboard &&<Route path="/Analytics" >
                <Route index={true} element={<Analytics pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="analytics" subPageName="analtyics"/>} />
                <Route path="Accounts" index={false} element={<DashboardAccount pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="accounts" subPageName="accounts"/>} />
              </Route>}
              <Route path="/Onboarding" >
                <Route index={true} element={<Onboarding pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="onboarding" subPageName="onboarding"/>} />
              </Route>
              {trialCheck && <Route path="Lead-Management/leadDetail/:id" element={<LeadDetail pageTypeHandler={pageTypeHandler} authToken={authToken} pageName="leadManagement" subPageName="leadDetail"/>}>
                <Route index={true} element={<DetailedHistory pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads"/>} />
                {/* <Route path="note/:name" index={false} element={<AddNote pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} />
                <Route path="note/:name-:noteId" index={false} element={<AddNote pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} />
                <Route path="task/:name" index={false} element={<AddTask pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
                {/* <Route path="task/:name-:taskId" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
                <Route path="add-mail" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} />
              </Route>}
              <Route path="/404" >
                <Route index={true} element={<Page404/>} />
              </Route>
              {/* <Route path="*" element={<Navigate to={trialCheck ? `/404`:"/TrialEnd"} />} /> */}
              <Route path="*" element={<Navigate to="/404" />} />
              <Route path="/TrialEnd" >
                <Route index={true} element={<TrialEnd/>} />
              </Route>
              {(userType == "3") && <Route path="/Setting" >
                <Route index={true} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="setting" subPageName="user"/>} />
                <Route path="token" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="token" authToken={authToken} />} />
                <Route path="addUser" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="addUser" authToken={authToken} />} />
                <Route path="editUser/:id" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="editUser" authToken={authToken} />} />
                <Route path="meeting" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="meeting" authToken={authToken} />} />
                <Route path="account" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="account" authToken={authToken} />} />
                <Route path="fields" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="fields" authToken={authToken} />} />
                <Route path="paymentHistory/" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="paymentHistory" authToken={authToken} />} />
                <Route path="billing/" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="billing" authToken={authToken} />} />
                <Route path="billing/:id" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="billing" authToken={authToken} />} />
                {/* <Route path="billingCalculate" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="billingCalculate" authToken={authToken} />} /> */}
                <Route path="calendly" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="calendly" authToken={authToken} />} />
                <Route path="calender" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="calender" authToken={authToken} />} />
                <Route path="notification" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="notification" authToken={authToken} />} />
                {/* <Route path="events" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="events" authToken={authToken} />} /> */}
                <Route path="eventSetting/:id" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="eventSetting" authToken={authToken} />} />
                <Route path="connect" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="connect" subPageName="connect" authToken={authToken} />} />
                <Route path="events" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="events" authToken={authToken} />} />
                <Route path="hubspot" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="hubspot" authToken={authToken} />} />
                <Route path="calendly?code=:code" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="calendly" authToken={authToken} />} />
                <Route path="eventSetting/:id" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="eventSetting" authToken={authToken} />} />
                <Route path="syncFields" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="syncFields" authToken={authToken} />} />
                <Route path="hubspotMapping" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="hubspotMapping" authToken={authToken} />} />
                <Route path="syncedHubspot" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="syncedHubspot" authToken={authToken} />} />
                <Route path="profile" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="profile" authToken={authToken} />} />
                <Route path="setup" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="setup" authToken={authToken} />} />
                <Route path="recommendedQuestions" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="recommendedQuestions" authToken={authToken} />} />
                <Route path="selectCalendar" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="selectCalendar" authToken={authToken} />} />
                <Route path="advanceIntent" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="advanceIntent" subPageName="advanceIntent" authToken={authToken} />} />
                {/* <Route path="addLeads" index={false} element={<ChatContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="chatAi" subPageName="addLeads" authToken={authToken} />} /> */}
                {/* <Route path="leadDetail/:id" index={false} element={<CRMContainer pageTypeHandler={pageTypeHandler} displayType="2" pageName="leadManagement" subPageName="leadDetail" authToken={authToken} />} /> */}
                {/* <Route path="leadDetail/:id/add-mail" index={false} element={<Emails pageTypeHandler={pageTypeHandler} authToken={authToken} pageFrom="Leads" />} /> */}
              </Route>}
              {<Route path="/Started" >
                <Route  index={true} element={<StartedComponent pageTypeHandler={pageTypeHandler} displayType="1" pageName="started" subPageName="getting" authToken={authToken} />} />
                <Route path="introduction" index={false} element={<StartedComponent pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="started" subPageName="introduction"/>} />
                <Route path="leadMangement" index={false} element={<StartedComponent pageTypeHandler={pageTypeHandler} displayType="1" authToken={authToken} pageName="started" subPageName="leadMangement"/>} />
              </Route>}
              {(userType == "4") && <Route path="/Setting" >                
                <Route path="notification" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="notification" authToken={authToken} />} />
                <Route path="profile" index={false} element={<SettingContainer pageTypeHandler={pageTypeHandler} displayType="1" pageName="setting" subPageName="profile" authToken={authToken} />} />
              </Route>}
            </Routes>
          </BrowserRouter>
        </div>
      { Cookies.get("conditionalLogout") !== true && <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />}
      <GoogleFontLoader fonts={fonts} />
      {/* {Object.keys(userInfoDetails)?.length > 0 && env_check === "production" && <ProductFruits workspaceCode="D7lfl3dzuNnwwnC8" language="en" user={userInfoDetails} />} */}
      {Object.keys(userInfoDetails)?.length > 0 && <ProductFruits workspaceCode="D7lfl3dzuNnwwnC8" language="en" user={userInfoDetails} />}
    </main>
  );
}

export default App;
